import { SharedState } from 'app/types-shared';

export const getFavouriteAdminAccess =
  (sharedState: SharedState): boolean => sharedState?.access?.adminPanel?.favourite?.administrationCentral;
